import { render, staticRenderFns } from "./tags-add.vue?vue&type=template&id=7c280e5f&scoped=true&"
import script from "./tags-add.vue?vue&type=script&lang=js&"
export * from "./tags-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c280e5f",
  null
  
)

export default component.exports